import { render, staticRenderFns } from "./Demtecnicos.vue?vue&type=template&id=de164912&"
import script from "./Demtecnicos.vue?vue&type=script&lang=js&"
export * from "./Demtecnicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports